import { Button } from "antd";
import { DocumentItemUI } from "../../../DocumentItems/DocumentItemUI/DocumentItemUI";
import classes from "./ApplicationDownloadFile.module.css";
import { DownloadOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { IApplicationDownloadFileProps } from "../../../../../interfaces/Ui/Application/IApplicationDownloadFileProps/IApplicationDownloadFile";

export const ApplicationDownloadFile = ({
  title,
  subtitle,
  subtitleProps = {},
  titleProps = {},
  onDownloadClick,
  className = "",
  icon = <ExclamationCircleOutlined width={20} />,
  ...restProps
}: IApplicationDownloadFileProps) => {
  const concatClassName = `${classes.document} ${classes.borderColor} ${className}`;
  const concatSubtitleClassName = `${classes.documentFileInfo} ${subtitleProps.className ? subtitleProps.className : ""}`;
  const concatTitleClassName = `${classes.documentTitle} ${titleProps.className ? titleProps.className : ""}`;

  return (
    <DocumentItemUI
      {...restProps}
      className={concatClassName}
      titleProps={{ ...titleProps, className: concatTitleClassName }}
      subtitleProps={{ ...subtitleProps, className: concatSubtitleClassName }}
      title={title}
      subtitle={
        <>
          {icon}
          {subtitle}
        </>
      }
    >
      <Button
        className={classes.downloadBtn}
        onClick={onDownloadClick}
        variant="outlined"
        color="primary"
        size="small"
        icon={<DownloadOutlined />}
      >
        Скачать
      </Button>
    </DocumentItemUI>
  );
};
